export const validateEmail = (value) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);

export const validateFloat = (value) =>
  /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/i.test(value);

export const validateInt = (value) => /^([+-]?[1-9]\d*|0)$/i.test(value);
